/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import HelpCenter from '../../../../app/pages/settings/helpCenter/HelpCenter'
import labelKey from '../../../../app/localization/label.json'
import { KTSVG } from '../../../helpers'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

const HelpDrawer = () => {
  const ktHelpClose = '#kt_help_close';
  return (
    <div
      id='kt_help'
      className='bg-body'
      data-kt-drawer='true'
      data-kt-drawer-name='help'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'350px', 'md': '525px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_help_toggle'
      data-kt-drawer-close={ktHelpClose}
    >
      {/* begin::Card */}
      <div className='card shadow-none rounded-0 w-100 ss-help-drawer-card'>
        {/* begin::Header */}
        <div className='card-header' id='kt_help_header'>
          <h5 className='card-title fw-bold text-gray-600 mb-0'>Help & Support Center</h5>
          <div className='card-toolbar ss-modal-header-actions'>
            <button
              type='button'
              id='kt_help_close'
              className='btn btn-sm btn-light ss-smart-btn  explore-btn-dismiss'
              onClick={() => {
                const closeBtn = document.getElementById('kt_help_close')
                closeBtn?.click()
              }}
            >
              {labelKey.cancel}
            </button>
            <button
              type='submit'
              form='ss-help-support-form'
              className='btn btn-sm btn-primary ss-smart-btn'
            >
              {labelKey.submit}
            </button>
            <Tooltip id='help-drawer-close' place='left' />
            {/* <button
              type='button'
              className='btn btn-sm btn-icon explore-btn-dismiss'
              id='kt_help_close'
              data-tooltip-id='help-drawer-close'
              data-tooltip-content='Close'
              aria-label='Close'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
            </button> */}
          </div>
        </div>
        {/* end::Header */}

        {/* begin::Body */}
        <div className='card-body' id='kt_help_body'>
          {/* begin::Content */}
          <div
            id='kt_help_scroll'
            className='hover-scroll-overlay-y'
            data-kt-scroll='true'
            data-kt-scroll-height='auto'
            data-kt-scroll-wrappers='#kt_help_body'
            data-kt-scroll-dependencies='#kt_help_header'
            data-kt-scroll-offset='5px'
          >
            <HelpCenter ktHelpClose={ktHelpClose} />
          </div>
          {/* end::Content */}
        </div>

        {/* end::Body */}
      </div>
      {/* end::Card */}
    </div>
  )
}

export { HelpDrawer }
